import styles from "./DefaultLoader.module.css";

import TextIconBrand from "./text.svg?react";
import IconS from "./s.svg?react";
import IconP from "./p.svg?react";
import { AnimationEvent } from "react";

interface DefaultLoaderProps {
  elementIsReady?: boolean;
  callBackEndAnimation?: () => void;
  timeAnimation?: `${number}ms`;
}

export const DefaultLoader = ({
  elementIsReady = true,
  callBackEndAnimation,
  timeAnimation = "1000ms",
}: DefaultLoaderProps) => {
  const endAnimationHidden = (e: AnimationEvent) => {
    if (e.animationName.includes("hidden")) {
      callBackEndAnimation?.();
    }
  };

  return (
    <div
      style={
        {
          "--time-animation-loader": `${timeAnimation}`,
        } as React.CSSProperties
      }
      id={styles.defaultLoader}
      className={elementIsReady ? styles.startHidden : ""}
      onAnimationEnd={endAnimationHidden}
    >
      <section className={styles.over}>
        <IconS className={styles.iconS} />
        <IconP className={styles.iconP} />
        <section className={styles.divForIcons}>
          <TextIconBrand className={styles.iconText} />
        </section>
      </section>
    </div>
  );
};
